import { useState } from 'react';
import { ErreurReseau, chargerFichier } from '../api';

/**
 * Export Excel d'un écran (docs/API.md § Comparateur et exports). Le classeur
 * est enregistré sur le poste, jamais ouvert dans un onglet ; l'API journalise
 * chaque export et n'y met les coordonnées que pour les profils RH.
 */
export function BoutonExport({
  chemin,
  nomParDefaut,
  libelle = 'Exporter en Excel',
}: {
  chemin: string;
  nomParDefaut: string;
  libelle?: string;
}) {
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);

  async function exporter(): Promise<void> {
    setEnCours(true);
    setErreur(null);
    try {
      const { contenu, nomFichier } = await chargerFichier(chemin);
      const lien = URL.createObjectURL(contenu);
      const ancre = window.document.createElement('a');
      ancre.href = lien;
      ancre.download = nomFichier ?? nomParDefaut;
      ancre.rel = 'noopener';
      window.document.body.append(ancre);
      ancre.click();
      ancre.remove();
      // Le navigateur lit l'URL après le clic : la libérer un peu plus tard.
      setTimeout(() => URL.revokeObjectURL(lien), 10_000);
    } catch (e) {
      setErreur(
        e instanceof ErreurReseau
          ? 'Export impossible sans connexion : réessayez une fois en ligne.'
          : e instanceof Error
            ? e.message
            : 'Export impossible',
      );
    } finally {
      setEnCours(false);
    }
  }

  return (
    <span className="export-excel">
      <button type="button" className="bouton-second" disabled={enCours} onClick={() => void exporter()}>
        {enCours ? 'Export en cours…' : libelle}
      </button>
      {erreur && (
        <span className="alerte" role="alert">
          {erreur}
        </span>
      )}
    </span>
  );
}
